import { NativeDateAdapter } from "@angular/material";

export class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
}


// WEBPACK FOOTER //
// ./src/app/utils/customDataAdapter.ts